import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api.ts';
import { Alert, Spinner, TextField } from '../components/ui.tsx';

export default function Reset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const token = params.get('token') ?? '';

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password.length < 10) {
      setError('La password deve avere almeno 10 caratteri.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.reset(token, password);
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 1200);
    } catch (err) {
      if (err instanceof ApiError && err.code === 'invalid_or_expired_token') {
        setError('Questo link è scaduto o è già stato usato. Chiedine uno nuovo.');
      } else if (err instanceof ApiError && err.issues?.[0]) {
        setError(err.issues[0].message);
      } else {
        setError('Non riesco a contattare il server.');
      }
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <div className="content narrow">
        <div className="stack center">
          <h1>Link incompleto</h1>
          <Alert kind="error">Manca il codice nel link. Aprilo direttamente dall’email.</Alert>
          <p><Link to="/forgot">Chiedi un nuovo link</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div className="content narrow">
      <div className="stack">
        <h1>Nuova password</h1>
        {done ? (
          <Alert kind="info">Password aggiornata. Ti porto al login.</Alert>
        ) : (
          <form className="stack" onSubmit={submit} noValidate>
            {error && <Alert kind="error">{error}</Alert>}
            <TextField id="password" label="Nuova password" type="password" autoComplete="new-password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              hint="Almeno 10 caratteri. Le sessioni aperte sugli altri dispositivi verranno chiuse." />
            <button className="btn block" type="submit" disabled={busy}>{busy ? <Spinner /> : 'Salva'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
